import { Injectable } from '@angular/core';
import { merge } from 'lodash';
import { ConfirmationComponent } from './confirmation.component';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmationConfig, StateConfirmation, ConfirmationActionConfig } from './confirmation.types';

@Injectable()
export class ConfirmationService {

  private _defaultConfig: ConfirmationConfig = {
    title: 'Confirm action',
    message: 'Are you sure you want to confirm this action?',
    icon: {
      show: true,
      options: {
        path: 'assets/lottie/info.json'
      },
      color: 'info',
      size: 20
    },
    actions: {
      confirm: {
        show: true,
        label: 'Confirm',
        color: 'primary'
      },
      cancel: {
        show: true,
        label: 'Cancel'
      }
    },
    dismissible: true
  };

  constructor(
    private _matDialog: MatDialog,
  ) { }

  open(config: ConfirmationConfig = {}, timeout?: number): Promise<any> {
    return new Promise((resolve) => {

      // Merge the user config with the default config
      const useConfig = merge({}, this._defaultConfig, config);

      // Open the dialog
      const dialog = this._matDialog.open(ConfirmationComponent, {
        autoFocus: false,
        disableClose: !useConfig.dismissible,
        data: useConfig,
        panelClass: 'confirmation-dialog-panel'
      });

      dialog.afterClosed().subscribe(p => resolve(p));

      if (timeout) {
        setTimeout(() => {
          this._matDialog.closeAll();
        }, timeout);
      }
    });
  }

  async normal(title: string, message: string, types: StateConfirmation, action?: ConfirmationActionConfig, showIcon = true, timeout?: number): Promise<any> {

    if (!action) {
      action = {
        cancel: {
          show: false
        },
        confirm: {
          show: true,
          label: 'ตกลง',
          color: 'primary'
        }
      };
    }


    const useConfig: ConfirmationConfig = {
      icon: {
        show: showIcon,
        options: {
          path: `assets/lottie/${types}.json`
        },
        color: types,
      },
      title: title,
      message: message,
      actions: action,
      dismissible: false
    };
    if (!timeout) {
      return this.open(useConfig, timeout);
    }
    else {
      return this.open(useConfig);
    }
  }

  info(title: string, message: string, action?: ConfirmationActionConfig, showIcon = true, timeout?: number): Promise<any> {
    return this.normal(title, message, 'info', action, showIcon, timeout);
  }

  success(title: string, message: string, action?: ConfirmationActionConfig, showIcon = true, timeout?: number): Promise<any> {
    return this.normal(title, message, 'success', action, showIcon, timeout);
  }

  warning(title: string, message: string, action?: ConfirmationActionConfig, showIcon = true, timeout?: number): Promise<any> {
    return this.normal(title, message, 'warning', action, showIcon);
  }

  error(title: string, message: string, action?: ConfirmationActionConfig, showIcon = true, timeout?: number): Promise<any> {
    return this.normal(title, message, 'error', action, showIcon);
  }

  confirmDelete(title: string, message: string, showIcon = true): Promise<any> {
    const action = {
      confirm: {
        show: true,
        label: 'Delete',
        color: 'primary'
      },
      cancel: {
        show: true,
        label: 'Cancel'
      }
    } as ConfirmationActionConfig;
    return this.normal(title, message, 'error', action, showIcon);
  }
  confirmReject(title: string, message: string, showIcon = true): Promise<any> {
    const action = {
      confirm: {
        show: true,
        label: 'Reject',
        color: 'primary'
      },
      cancel: {
        show: true,
        label: 'Cancel'
      }
    } as ConfirmationActionConfig;
    return this.normal(title, message, 'error', action, showIcon);
  }
  confirmSave(title: string, message: string, showIcon = true): Promise<any> {
    const action = {
      confirm: {
        show: true,
        label: 'Save',
        color: 'primary'
      },
      cancel: {
        show: true,
        label: 'Cancel'
      }
    } as ConfirmationActionConfig;
    return this.normal(title, message, 'warning', action, showIcon);
  }

  confirmWarning(title: string, message: string, lableConfirm: string, lableCancel: string, showIcon = true): Promise<any> {
    const action = {
      confirm: {
        show: true,
        label: lableConfirm,
        color: 'primary'
      },
      cancel: {
        show: true,
        label: lableCancel
      }
    } as ConfirmationActionConfig;
    return this.normal(title, message, 'warning', action, showIcon);
  }
}
